export const navigationItems = [
  {
    name: 'About',
    url: '/about',
  },
];
